import { Paper, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, TextField, InputAdornment } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import { useState, useEffect } from "react"
import Layout from "../../Frames/Layout"
import API from "../../../services/API/Emails"
import Loader from '../../Tools/Loader'
import Toast from '../../Tools/Toast'
import { useMemo } from "react";
import { Link } from "react-router-dom";
import Tip from "../../Tools/Tip";
import Toogle from "../../Inputs/Toggle"

export default function List(){

    const [items, setItems] = useState(null)
    const [error, setError] = useState(false)
    const [search, setSearch] = useState('')

    useEffect(() => {
        API.getAll()
            .then(r => setItems(r.data))
            .catch(e => setError(true))
    }, [])

    const list = useMemo(() => 
        (items || [])
            .filter(i => (i.title + i.subject).toLowerCase().includes(search.toLowerCase()))
            .sort((a,b) => (a.class + a.title) > (b.class + b.title) ? 1 : -1)
    , [items, search])


    const toggle = i => {
        const old = [...items];
        let copy = [...items];
        copy = copy.map(e => e.id === i.id ? {...e, active: !e.active} : e);

        API.toggle(i.id).catch(() => setItems(old))

        return setItems(copy);
    }


    return <Layout title="Emails" tab="emails" menu="marketing">

        <TextField
            label='Rechercher'
            type='search'
            size='small'
            value={search}
            onChange={e => setSearch(e.target.value)}
            InputProps={{
                startAdornment: <InputAdornment position='start'><SearchIcon/></InputAdornment>
            }}
            sx={{mb: 2}}
        />

        <TableContainer component={Paper}>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell><b>Email</b></TableCell>
                        <TableCell><b>Objet</b></TableCell>
                        <TableCell><b>Activé</b></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.map(i => 
                        <TableRow key={i.id}>
                            <TableCell>{i.title}</TableCell>
                            <TableCell>{i.subject}</TableCell>
                            <TableCell>
                                <Toogle value={i.active} onChange={() => toggle(i)} />
                            </TableCell>
                            <TableCell>
                                <Link to={`/marketing/emails/${i.id}`}>
                                    <Tip type='edit' />
                                </Link>
                            </TableCell>
                        </TableRow>    
                    )}
                </TableBody>
            </Table>

        </TableContainer>


        {!items && <Loader/>}
        

        <Toast
            open={error}
            severiry='error'
            message="Une erreur s'est produite, les données n'ont pas pu être chargées"
            onClose={() => setError(false)}
        />

    </Layout>
}